import { render, staticRenderFns } from "./related-vehicles.vue?vue&type=template&id=75f831f8&scoped=true&"
import script from "./related-vehicles.vue?vue&type=script&lang=js&"
export * from "./related-vehicles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f831f8",
  null
  
)

export default component.exports